export class DepartmentModel {
  id!: number;
  parentId!: number;
  path!: number;
  name!: string;
  totalEmployees!: number;
  locationIds!: string[];
}

export class SearchDepartmentFilter {
  pageIndex: number = 0;
  pageSize: number = 10;
  keyWord: string = '';
  getForSetup: boolean = true;
}

export class DepartmentField {
  id: any;
  departmentId: any;
  name!: string;
  oldName!: string;
  description: string = '';
  parentId: any;
  departmentName!: string;
  oldDepartmentName!: string;
  path!: string;
  isCompany!: boolean;
  organizationNo: string = '';
  countryId: any = 1;
  country!: string;
  visitAddress1: string = '';
  visitAddress2: string = '';
  visitAddress3: string = '';
  address1: string = '';
  address2: string = '';
  address3: string = '';
  phone: string = '';
  fax: string = '';
  email: string = '';
  uRL: string = '';
  childCount!: number;
  level!: number;
  leaderName!: string;
  totalEmployees!: number;
}
